import { createPluginFactory } from '@udecode/plate-core';

import { withErrorHandling } from './withErrorHandling';

export const KEY_ERROR_HANDLING = 'error_handling';

/**
 * Enables support for deserializing inserted content from HTML format to Slate format.
 */
export const createErrorHandlingPlugin = createPluginFactory({
  key: KEY_ERROR_HANDLING,
  withOverrides: withErrorHandling,
});
